module.exports = __webpack_public_path__ + "static/media/pamain-extrabold.272a2d7b.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain-extrabold.eot
// module id = ./src/assets/fonts/pamain-extrabold.eot
// module chunks = 0